window.addEventListener("load", function () {
    let cameras_carousel = this.document.querySelectorAll(
        ".box-cameras-carousel .swiper"
    );

    if (!cameras_carousel.length) return;

    cameras_carousel.forEach((element) => {
        var partners_swiper = new Swiper(element, {
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            speed: 550,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: element.parentNode.querySelector(
                    ".carousel-navigation .next"
                ),
                prevEl: element.parentNode.querySelector(
                    ".carousel-navigation .prev"
                ),
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 30,
                },
            },
        });
    });
});
